/**
 * @generated SignedSource<<2ddf4c0c0e1a89565cf458d1c503fd1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddSlackAccountForTeamMutationInput = {
  clientMutationId?: string | null;
  orgRelayId: string;
  redirect: string;
  teamId: string;
  verificationCode: string;
};
export type AddSlackAccountForTeamMutation$variables = {
  input: AddSlackAccountForTeamMutationInput;
};
export type AddSlackAccountForTeamMutation$data = {
  readonly addSlackAccountForTeam: {
    readonly clientMutationId: string | null;
  } | null;
};
export type AddSlackAccountForTeamMutation = {
  variables: AddSlackAccountForTeamMutation$variables;
  response: AddSlackAccountForTeamMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddSlackAccountForTeamMutationPayload",
    "kind": "LinkedField",
    "name": "addSlackAccountForTeam",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddSlackAccountForTeamMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddSlackAccountForTeamMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "09e4cce584b23f2c8c97ff622c56ba47",
    "id": null,
    "metadata": {},
    "name": "AddSlackAccountForTeamMutation",
    "operationKind": "mutation",
    "text": "mutation AddSlackAccountForTeamMutation(\n  $input: AddSlackAccountForTeamMutationInput!\n) {\n  addSlackAccountForTeam(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "346ae8d770606f89404d44be396b5713";

export default node;
